import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { SocialLinks } from "@/components/SocialLinks";
import { SearchBar } from "@/components/SearchBar";
import { useSettings } from "@/context/SettingsContext";

const link = "hover:text-white transition-colors";

export const Footer = () => {
  const { settings } = useSettings();

  return (
    <footer className="border-t border-white/10 bg-[#050B17]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-6 pb-5 space-y-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <p className="eyebrow mb-1.5">Looking for something?</p>
            <p className="text-sm text-slate-400">Search every episode across the network.</p>
          </div>
          <SearchBar className="w-full md:w-[420px]" testId="footer-search-input" />
        </div>
        <div className="border-t border-white/10 pt-4 flex flex-col md:flex-row items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid="footer-logo-link">
          <Logo size={28} />
          <span className="font-display font-black text-base uppercase tracking-tight text-white">Underdog Podcasts</span>
        </Link>
        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 text-sm text-slate-400" data-testid="footer-links">
          <Link to="/shows" className={link} data-testid="footer-shows-link">All Shows</Link>
          <a href="/#videos" className={link}>Videos</a>
          <Link to="/hosts" className={link} data-testid="footer-hosts-link">Hosts</Link>
          <Link to="/search" className={link} data-testid="footer-search-link">Search</Link>
          <Link to="/join" className={`${link} text-sky-400`} data-testid="footer-join-link">Join The Underdog</Link>
          <Link to="/advertise" className={link} data-testid="footer-advertise-link">Advertise</Link>
          <Link to="/articles" className={link} data-testid="footer-articles-link">Articles</Link>
          <Link to="/review" className={link} data-testid="footer-review-link">Leave a review</Link>
          <Link to="/contact" className={link} data-testid="footer-contact-link">Contact</Link>
          <Link to="/privacy" className={link} data-testid="footer-privacy-link">Privacy</Link>
          <Link to="/admin/login" className={link} data-testid="footer-admin-link">Admin</Link>
        </nav>
        <div className="flex items-center gap-4 shrink-0">
          <SocialLinks settings={settings || {}} size={15} className="flex" />
          <p className="font-mono text-[11px] text-slate-500 whitespace-nowrap" data-testid="footer-copyright">© {new Date().getFullYear()} Underdog Podcasts</p>
        </div>
        </div>
      </div>
    </footer>
  );
};
